import React from 'react';
import { Route, Routes } from 'react-router-dom';

import CaptureBadges from '@domains/Badges/Capture/PDF/Badges';
import { CaptureLabelPDF } from '@domains/Badges/Capture/PDF/Labels';

const CapturePDF = () => (
  <Routes>
    <Route path="badges/simple_label" element={<CaptureLabelPDF />} />
    {/* This first route can be removed once the FF is enabled for all users.
        Confirm with foundation and then remove with EXP-19211
        Update: foundation is still using the old path, so we need to keep it for now */}
    <Route path="badges/:resourceId" element={<CaptureBadges />} />
    <Route path="badges/print_by_yourself/:resourceId" element={<CaptureBadges />} />
    <Route path="badges/pre_print/:resourceId" element={<CaptureBadges />} />
    <Route path="*" element={<>Unknown resource type</>} />
  </Routes>
);

export default CapturePDF;
